import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Privacy from "./Screens/Privacy";
import AppSpaceHomePage from "./Screens/AppSpaceHomePage";
import AboutUsPage from "./Screens/AboutUsPage";
import ContactPage from "./Screens/ContactPage";
import FaqScreen from "./Screens/FaqScreen";
import FaqAll from "./Comp/FaqAll";
import CollageMakerFaq from "./Comp/CollageMakerFaq";
import VideoEditorFaq from "./Comp/VideoEditorFaq";
import CalmSleepFaq from "./Comp/CalmSleepFaq";
import Blogs from "./Screens/Blogs";
import DynamicBlog from "./Screens/DynamicBlog";
import KnifeHitFaq from "./Comp/KnifeHitFaq";
import Games from "./Screens/Games/Games";
import CalmVerse from "./Screens/CalmVerse/CalmVerse";
import Hdx from "./Screens/HdxVideoPlayer/Hdxvideo";
import ScrollToTop from "./Comp/ScrollToTop";
import ZXFileManager from "./Screens/PrivacyPolicy/ZXFileManager";
import ProntoVPN from "./Screens/Vpn/ProntoVPN";
import CastToTVFAQs from "./Screens/Faqs/CastToTVFAQs";
import CastToTvPP from "./Screens/PrivacyPolicy/CastToTvPP";
import Cleaner from "./Screens/PrivacyPolicy/Cleaner";
import PixGrid from "./Screens/PrivacyPolicy/PixGrid";
import PDFReader from "./Screens/PrivacyPolicy/PDFReader";
import GoCleanr from "./Screens/Faqs/GoCleanr";
import CalcSafe from "./Screens/Faqs/CalcSafe";
import PDFReaderFAQs from "./Screens/Faqs/PDFReaderFAQs";
import HoleKing from "./Screens/HoleKing";
import BladeKing from "./Screens/BladeKing";
import ZXFileManagerPage from "./Screens/ZXFileManagerPage";

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<AppSpaceHomePage />} />
        <Route path="/faq" element={<FaqScreen />}>
          <Route index element={<FaqAll />} />
          <Route path="collage-maker" element={<CollageMakerFaq />} />
          <Route path="video-editor" element={<VideoEditorFaq />} />
          <Route path="calm-sleep" element={<CalmSleepFaq />} />
          <Route path="knife-hit" element={<KnifeHitFaq />} />
        </Route>
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/privacy/zx-file-manager" element={<ZXFileManager />} />
        <Route path="/zx-file-manager" element={<ZXFileManagerPage />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:blogId" element={<DynamicBlog />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/games" element={<Games />} />
        <Route path="/calmverse" element={<CalmVerse />} />
        <Route path="/hdxvideoplayer" element={<Hdx />} />
        <Route path="/prontoVPN" element={<ProntoVPN />} />
        <Route path="/faq/casttotv" element={<CastToTVFAQs />} />
        <Route path="/privacypolicy/casttotv" element={<CastToTvPP />} />
        <Route path="/privacypolicy/cleaner" element={<Cleaner />} />
        <Route path="/privacypolicy/pixgrid" element={<PixGrid />} />
        <Route path="/privacypolicy/pdfreader" element={<PDFReader />} />
        <Route path="/faq/gocleanr" element={<GoCleanr />} />
        <Route path="/faq/calcsafe" element={<CalcSafe />} />
        <Route path="/faq/pdfreader" element={<PDFReaderFAQs />} />
        <Route path="/holeking/deleteaccount" element={<HoleKing />} />
        <Route path="/bladeking/deleteaccount" element={<BladeKing />} />
        <Route path="/blade-king/deleteaccount" element={<BladeKing />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
